import classNames from "classnames";
import styles from "./AscPersonalSupportCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import PersonalSupportIllustration from "../../../assets/illustrations/personal-support.svg";
// import AscButton from "../../AscButton/AscButton";

export interface AscGoToChallengesCardProps {
  className?: string;
  onSend?: () => void;
}

export default function AscPersonalSupportCard({
  className,
  onSend,
}: AscGoToChallengesCardProps) {
  return (
    <AscGenericCard
      title="Personal Support"
      data-testid="asc-personal-support-card"
      className={classNames(styles.ground, className)}
      coverImageUrl={PersonalSupportIllustration}
      titleClassName={styles.title}
      bodyClassName={styles.body}
      contentClassName={styles.content}
      imageClassName={styles.cardImage}
    >
      Couldn’t find what you’re looking for? Reach out to us at:
      {/* <AscButton
        variant="white"
        fullWidth
        className={styles.button}
        onClick={onSend}
      >
        Send an inquiry
      </AscButton> */}
      <a
        href="mailto:help@buildmyedge.com"
        target="_blank"
        rel="noreferrer"
        className={styles.email}
      >
        help@buildmyedge.com
      </a>
    </AscGenericCard>
  );
}
